import { useEffect } from 'react';
export const useScroll = ({ open, callback }) => {
    useEffect(() => {
        if (!open)
            return;
        window.addEventListener('scroll', callback);
        return () => {
            window.removeEventListener('scroll', callback);
        };
    }, [open, callback]);
};
//# sourceMappingURL=use-scroll.js.map